import Modal from 'antd/lib/modal/Modal';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setWelcomeModalOptions } from '../../actions/ui';
import { AddAppsComponent } from './AddAppsComponent';
import { OnboardingCTAs } from './OnboardingCTAs';
import * as Storage from '../../helpers/localStorageHelper';
import { StringKeyedDictionary } from '../../typescriptHelpers';
import { RootState } from '../../reducers/reducers';

interface WelcomeToRunwayModalProps {
    orgId: string;
    open: boolean;
    showAsOnboarding: boolean;
    onCancel: () => void;
    onShowDemoMode: () => void;
    shouldDirectlyShowNewAppFlow?: boolean;
}

export const WelcomeToRunwayModal: React.FC<WelcomeToRunwayModalProps> = (props) => {
    const { shouldDirectlyShowNewAppFlow, ...rest } = props;
    const dispatch = useDispatch();

    const userId = useSelector((state: RootState) => state.user.id);

    React.useEffect(() => {
        if (props.open) {
            setUserHasViewedOnboarding();
        }
    }, [props.open]);

    const setUserHasViewedOnboarding = () => {
        const userHasViewedOnboarding: StringKeyedDictionary<boolean> = Storage.getItem(
            Storage.USER_HAS_VIEWED_ONBOARDING,
        );
        const newUserHasViewedOnboarding = {
            ...userHasViewedOnboarding,
            [userId]: true,
        };

        Storage.setItem(Storage.USER_HAS_VIEWED_ONBOARDING, newUserHasViewedOnboarding);
    };

    return (
        <Modal
            footer={null}
            maskClosable={!props.showAsOnboarding}
            closable={!props.showAsOnboarding}
            open={props.open}
            width={'85%'}
            centered
            bodyStyle={{
                padding: 36,
                borderRadius: 8,
                backgroundColor: 'white',
            }}
            destroyOnClose
            onCancel={props.onCancel}
            style={{ maxWidth: 1130 }}
        >
            {shouldDirectlyShowNewAppFlow ?
                <AddAppsComponent {...rest} />
            :   <OnboardingCTAs
                    onAddAppClicked={() => {
                        dispatch(
                            setWelcomeModalOptions({
                                shouldShowWelcomeModal: true,
                                shouldDirectlyShowNewAppFlow: true,
                            }),
                        );
                    }}
                />
            }
        </Modal>
    );
};
